import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import './styles/context-aware.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root')!);

const render = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

render();

// Register service worker for push notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function() {
    navigator.serviceWorker.register('/sw.js')
      .then(function(registration) {
        console.log('ServiceWorker registration successful:', registration);
      })
      .catch(function(error) {
        console.error('ServiceWorker registration failed:', error);
      });
  });
}

// Hot Module Replacement (HMR)
if (import.meta.hot) {
  import.meta.hot.accept('./App', () => {
    console.log('🔄 HMR Update');
    render();
  });
}
